import { FC } from "react";
import { GeneralSelectInputs } from "models/Client/GeneralSelectInputs";

import { MazakaSelect } from "../MazakaSelect";
import useCapitalize from "../Adress/helpers/useCapitalize";
import { useGetComplaintReasones } from "./ServerSideStates";

const GeneralComplaintReason: FC<GeneralSelectInputs> = (props) => {
 

  const reasones = useGetComplaintReasones()
  let { capitalize } = useCapitalize();
  return (
    <>
        <MazakaSelect
              name={props.name}
              xs={props.xs}
              sm={props.sm}
              md={props.md}
              lg={props.lg}
              xl={props.xl}
              loading={reasones.isLoading || reasones.isFetching}
              disabled={reasones.isLoading || reasones.isFetching || props.disabled}
              className={props.className}
              showSearch={true}
              allowClear={props.allowClear || false}
              filterOption={(input, option: any) =>
                (option.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              label={props.label}
              options={
                reasones.data?.data
                  ? reasones.data?.data.map((item: any) => {
                      return {
                        key: item.id,
                        value: item.id,
                        label: capitalize(item.name),
                      };
                    })
                  : []
              }
              placeholder={props.placeholder}
              mode={props.mode}
              onChange={props.onChange}
              value={props.value}
              rules={props.rules}
            />
    </>
  );
};

export default GeneralComplaintReason;
